import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { actions } from "../../../../ReservePage/_redux/reserveRedux";
import MobileFilterDialog from "./MobileFilterDialog";

const PriceAndTimeFilter = (props) => {
  const [isPriceSorted, setIsPriceSorted] = React.useState(false);
  const [isTimeSorted, setIsTimeSorted] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  let { state } = useSelector((state) => ({
    state: state.reserve,
  }));

  const dispatch = useDispatch();

  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  const priceSorter = () => {
    let sortedArr;
    if (!isPriceSorted) {
      sortedArr = state.mockTravels.sort(function(a, b) {
        return a.basePrice - b.basePrice;
      });
      setIsPriceSorted(true);
    } else if (isPriceSorted) {
      sortedArr = state.mockTravels.sort(function(a, b) {
        return b.basePrice - a.basePrice;
      });
      setIsPriceSorted(false);
    }
    dispatch(actions.setMockTravels(sortedArr));
  };

  const timeSorter = () => {
    let sortedArr;
    if (!isTimeSorted) {
      sortedArr = state.mockTravels.sort(function(a, b) {
        return new Date(a.departureDatetime) - new Date(b.departureDatetime);
      });
      setIsTimeSorted(true);
    } else if (isTimeSorted) {
      sortedArr = state.mockTravels.sort(function(a, b) {
        return new Date(b.departureDatetime) - new Date(a.departureDatetime);
      });
      setIsTimeSorted(false);
    }
    dispatch(actions.setMockTravels(sortedArr));
  };

  return (
    <div
      className="mt-5 h-auto d-flex flex-wrap"
      style={{ minHeight: 35, marginBottom: "35px", borderRadius: "13px" }}
    >
      <div
        className="col-2 col-md-3"
        style={{ padding: "0px 0px 0px 5px", cursor: "pointer" }}
      >
        <div
          className="d-flex d-lg-none justify-content-center my-auto p-5 dg1-border bg-secondary align-items-center h-100"
          style={{ paddingTop: "2.5%", borderRadius: "12px", gap: "10px" }}
          onClick={() => {
            setOpen(true);
          }}
        >
          <h5
            style={{ opacity: "0.85", fontSize: "18px" }}
            className="d-none d-md-block my-auto"
          >
            فیلتر
          </h5>
          <i
            className="fa fa-filter align-self-center"
            style={{ color: "#6dd06d" }}
          ></i>
        </div>
      </div>
      <div
        className="col-10 col-md-9 col-lg-12"
        style={{ padding: "0px 5px 0px 0px" }}
      >
        <div
          className="d-flex justify-content-between my-auto py-5 px-3 dg1-border bg-secondary"
          style={{ paddingTop: "2.5%", borderRadius: "12px" }}
        >
          <a
            className="d-flex align-items-center"
            style={{ gap: 5 }}
            onClick={() => timeSorter()}
          >
            <h5
              style={{ opacity: "0.85", fontSize: "18px" }}
              className="my-auto"
            >
              ساعت حرکت
            </h5>
            <i
              className={`sort-icons ${
                isTimeSorted
                  ? "fa fa-sort-amount-up-alt"
                  : "fa fa-sort-amount-down-alt"
              }`}
            ></i>
          </a>
          <a
            className="d-flex align-items-center"
            style={{ gap: 5 }}
            onClick={() => priceSorter()}
          >
            <h5
              style={{ opacity: "0.85", fontSize: "18px" }}
              className="my-auto"
            >
              قیمت
            </h5>
            <i
              className={`sort-icons ${
                isPriceSorted
                  ? "fa fa-sort-amount-up-alt"
                  : "fa fa-sort-amount-down-alt"
              }`}
              onClick={() => {}}
            ></i>
          </a>
        </div>
      </div>
      {isTabletOrMobile && <MobileFilterDialog openObj={{ open, setOpen }} />}
    </div>
  );
};

export default PriceAndTimeFilter;
